<script setup lang="ts">
// Pages that manage their own scrolling (editor, support chat) opt in with
// definePageMeta({ fullHeight: true }). A flag instead of a separate layout:
// switching layouts would remount the whole shell (sidebar, toolbar, prompts)
// on every navigation to/from those pages.
const route = useRoute()
const fullHeight = computed(() => !!route.meta.fullHeight)
</script>

<template>
  <SidebarLayout :full-height="fullHeight">
    <AppConfirmDialog />
    <slot />
  </SidebarLayout>
</template>

<style>
:root {
  --p-accordion-header-background: var(--color-slate-50) !important;
  --p-accordion-header-active-background: var(--color-primary-500) !important;
  --p-accordion-header-active-hover-background: var(--color-primary-500) !important;

  .p-accordionpanel:nth-of-type(odd) {
    --p-accordion-header-background: var(--color-slate-100) !important;
  }
}

html.dark-mode {
  --p-accordion-header-background: var(--color-slate-800) !important;

  .p-accordionpanel:nth-of-type(odd) {
    --p-accordion-header-background: var(--color-slate-900) !important;
  }

  --p-accordion-content-background: var(--color-slate-800) !important;
  --p-tabs-tabpanel-background: var(--color-slate-800) !important;
  --p-tabs-tablist-background: var(--color-slate-800) !important;
}

.p-autocomplete .p-inputtext {
  width: 100%;
}

html.light .jexcel > tbody > tr > td.readonly {
  color: black !important;
}

html.dark-mode .jexcel > tbody > tr > td.readonly {
  color: white !important;
}

html.dark-mode .jexcel tbody .jexcel_freezed {
  position: relative;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity)) !important;
  border-right: 2px white;
  -webkit-box-shadow: 2px 0px 0px 0px rgba(255, 255, 255, 1) !important;
  -moz-box-shadow: 2px 0px 0px 0px rgba(255, 255, 255, 1) !important;
  box-shadow: 2px 0px 0px 0px rgba(255, 255, 255, 1) !important;
}

.jexcel_content {
  box-shadow: none !important;
}
</style>
